export const toastConfigure = {
  pauseOnFocusLoss: false,
  autoClose: 3000,
  role: "alert",
  draggable: false,
};
